import styled from "styled-components";

import ContentManagementSystem from "src/features/content-management-system";

export const CMSBanner = styled(ContentManagementSystem)`
  margin: 40px 0;
`;

export const CMSContainer = styled.div`
  margin: 0 auto;
  max-width: 880px;
`;

export const CMSWrapper = styled.section`
  padding: 0 40px;
`;
